const TRACKS_PER_COLUMN = 3;
export const TABLE_COLUMN_TRACKS = ['minmax(min-content, 1fr)', 'minmax(min-content, max-content)', 'minmax(min-content, 1fr)'];
const COLUMN_TRACKS = TABLE_COLUMN_TRACKS.join(' ');

interface ITableGridPlacement {
    templateColumns: string;
    startById: Record<string, number>;
    parentColumns: string[];
}

export function getTableGridColumn (start: number, span = 1): string {
    return `${start} / span ${TRACKS_PER_COLUMN * span}`;
}

/** Map the visible order, including separate runs of the same parent, to shared tracks. */
export function getTableGridPlacement (
    headerIds: string[],
    parentSpans: number[],
    checkable: boolean,
): ITableGridPlacement {
    const firstColumn = checkable ? 2 : 1;
    let parentStart = firstColumn;
    return {
        templateColumns: [
            ...(checkable ? ['max-content'] : []),
            ...(headerIds.length ? [`repeat(${headerIds.length}, ${COLUMN_TRACKS})`] : []),
        ].join(' ') || 'none',
        startById: Object.fromEntries(headerIds.map((id, index) => [id, firstColumn + TRACKS_PER_COLUMN * index])),
        parentColumns: parentSpans.map(span => {
            const column = getTableGridColumn(parentStart, span);
            parentStart += TRACKS_PER_COLUMN * span;
            return column;
        }),
    };
}

/** A leaf can cover both header rows, but must not create rows outside its group. */
export function getTableHeaderGridRow (rowSpan: number, grouped: boolean): string {
    if (!grouped) return '1';
    return rowSpan > 1 ? '1 / span 2' : '2';
}
